import type {
  LeadGenerationTireOfferDraftCreateApiData,
  LeadGenerationTireOfferDraftCreateApiResponses,
  LeadGenerationTireOfferSuggestionApiData,
  LeadGenerationTireOfferSuggestionApiResponses,
  TireQuoteTreadReadingDraftCreateApiData,
  TireQuoteTreadReadingDraftCreateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

/** The tire offer the system suggests for a new tires lead or a cold lead's tread reading, and the draft offer made from it. */
export const getLeadTireOfferUrls = {
  getLeadGenerationTireOfferSuggestion: dataEndpoint<
    LeadGenerationTireOfferSuggestionApiData,
    LeadGenerationTireOfferSuggestionApiResponses
  >({
    getUrl: ({ leadGenerationId, ...queryParams }) =>
      apiUrl(`lead-generations/${leadGenerationId}/tire-offer-suggestion/`, queryParams)
  }),
  postCreateLeadGenerationTireOfferDraft: responseEndpoint<
    LeadGenerationTireOfferDraftCreateApiData,
    LeadGenerationTireOfferDraftCreateApiResponses
  >({
    getUrl: ({ leadGenerationId }) => apiUrl(`lead-generations/${leadGenerationId}/tire-offer-draft/`),
    getBody: (data) => data
  }),
  postCreateTireOfferDraftFromTreadReading: responseEndpoint<
    TireQuoteTreadReadingDraftCreateApiData,
    TireQuoteTreadReadingDraftCreateApiResponses
  >({
    getUrl: ({ readingId }) => apiUrl(`car-wheel-measurements/${readingId}/tire-offer-draft/`),
    getBody: (data) => data
  })
};
